import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Appoinment.css";

const Appoinment = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    
      const [isFormValid, setIsFormValid] = useState(null);
    
      const navigate = useNavigate();  // Use useNavigate instead of useHistory
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
    
        const isValid = validateForm();
    
        if (isValid) {
          setIsFormValid(true);
          // Redirect to the "/approved" route
          navigate("/approved");  // Use navigate instead of history.push
        } else {
          setIsFormValid(false);
        }
      };
    
      const validateForm = () => {
        const { name, email, phone, subject, message } = formData;
    
        // Basic form validation logic (customize as needed)
        const isValid =
          name.trim() !== "" &&
          email.trim() !== "" &&
          phone.trim() !== "" &&
          subject.trim() !== "" &&
          message.trim() !== "";
    
        return isValid;
      };

  return (
    <section className="appoinment-wrapper" id="appoinment">
      <Container>
        <Row>
          <Col sm={12} md={12}>
            <div className="section-title">
              <h1 className="mt-5" id="appointmentHead">
                Book an <span>Appointment</span>
              </h1>
            </div>
            <div className="appoinment-form">
              <form onSubmit={handleSubmit} className="row">
                <Col md={6} lg={6}>
                  <input
                    type="text"
                    placeholder="Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={6} lg={6}>
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={6} lg={6}>
                  <input
                    type="tel"
                    placeholder="Phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={6} lg={6}>
                  <input
                    type="text"
                    placeholder="Title/Subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={12} lg={12}>
                  <textarea
                    name="message"
                    cols="30"
                    rows="10"
                    placeholder="Write your Message...."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </Col>
                <div className="div justify-content-center">
                <button
                  type="submit"
                  className="theme-btn btn-fill form-btn mt-5 sendBtn"
                >
                  Send
                </button>
                </div>
              </form>
              {isFormValid === true && (
                <p>Form is valid. Redirecting...</p>
              )}
              {isFormValid === false && isFormValid !== null && (
                <p>Please fill out the form correctly.</p>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Appoinment;
